/** Kanban column definitions — status + completed result buckets */
export const PIPELINE_COLUMNS = [
  { id: 'taslak', label: 'Taslak', status: 'Taslak', color: '#F1C40F' },
  { id: 'canli', label: 'Canlı', status: 'Canlı', color: '#0abc2a' },
  { id: 'kazandi', label: 'Kazandı', status: 'Durduruldu', color: '#27AE60' },
  { id: 'kaybetti', label: 'Kaybetti', status: 'Durduruldu', color: '#E74C3C' },
  { id: 'etkisiz', label: 'Etkisiz', status: 'Durduruldu', color: '#95A5A6' },
];

/** Resolve which column a test card belongs in */
export const getPipelineColumnId = (test) => {
  if (test.status === 'Taslak') return 'taslak';
  if (test.status === 'Canlı') return 'canli';
  if (test.status === 'Durduruldu') {
    const results = test.resultStatuses || [];
    if (results.includes('Kazandı')) return 'kazandi';
    if (results.includes('Kaybetti')) return 'kaybetti';
    return 'etkisiz';
  }
  return 'taslak';
};

/** Flatten grouped brand reports into pipeline cards */
export const flattenBrandReports = (brandGroups) =>
  brandGroups.flatMap((brand) =>
    (brand.tests || []).map((test) => ({
      ...test,
      brandName: brand.name,
    })),
  );

/** Group flat tests by pipeline column id */
export const groupTestsByPipelineColumn = (tests) => {
  const groups = Object.fromEntries(PIPELINE_COLUMNS.map((c) => [c.id, []]));
  tests.forEach((test) => {
    groups[getPipelineColumnId(test)].push(test);
  });
  return groups;
};

/** Map drop target column to API status value */
export const getStatusForColumn = (columnId) => {
  const col = PIPELINE_COLUMNS.find((c) => c.id === columnId);
  return col?.status || 'Taslak';
};
